import { render, staticRenderFns } from "./expandable.vue?vue&type=template&id=3953070f&scoped=true&lang=html"
import script from "./expandable.vue?vue&type=script&lang=js"
export * from "./expandable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3953070f",
  null
  
)

export default component.exports